import React, { useState, useEffect } from "react";
import * as AiIcons from "react-icons/ai";
import Alert from "react-bootstrap/Alert";
import {
  MDBBtn,
  MDBSpinner,
  MDBCard,
  MDBCardBody,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBInputGroup,
  MDBInput,
} from "mdb-react-ui-kit";

import config from "../config.json";
import "./Login.css";
import { Form } from "react-router-dom";

function Login({ fetchedLogin, setLoggedIn, setUserType, setUserName }) {
  const [justifyActive, setJustifyActive] = useState("tab1");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [userType, selectUserType] = useState("");
  const [passwordFeedback, setPasswordFeedback] = useState("");
  const [usernameFeedback, setUsernameFeedback] = useState("");
  const [feedback, setFeedback] = useState("");
  const [isValidPass, setIsValidPass] = useState(false);
  const [isValidUser, setIsValidUser] = useState(false);
  const [isValidLoginForm, setIsValidLoginForm] = useState(false);
  const [loginSubmit, setLoginSubmit] = useState(false);
  const [registerSubmit, setRegisterSubmit] = useState(false);

  const handleJustifyClick = (value) => {
    const firstNameInput = document.getElementById("username");
    firstNameInput.value = null;
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };
  const submitLogin = async (e) => {
    e.preventDefault();

    if (!fetchedLogin) {
      setFeedback(
        "Server connection failed! Please try again later.\nIf the issue persists please contact the site adminstrator"
      );
      setLoginSubmit(false);
      return;
    }
    setLoginSubmit(true);
    //console.log("Data submitted for login!");

    const response = await fetch(
      config.domainName + ":" + config.port + "/api/login",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          name,
          password,
        }),
      }
    );

    const content = await response.json();
    if (content.message === "Incorrect password entered") {
      setPasswordFeedback("Incorrect Password. Please try again!");
      setFeedback("Incorrect Password. Please try again!");
      setIsValidPass(false);
      setLoginSubmit(false);
    }
    if (content.message === "User not found in the database!") {
      setUsernameFeedback(
        "User does not exist. Please enter a valid username!"
      );
      setFeedback("User does not exist. Please enter a valid username!");
      setIsValidUser(false);
      setLoginSubmit(false);
    }
    if (content.message === "success") {
      setIsValidPass(true);
      setIsValidUser(true);
      setLoggedIn(true);
      setUserType(content["user type"]);
      setUserName(content["user name"]);
    }
  };
  const submitRegister = async (e) => {
    setRegisterSubmit(true);
    e.preventDefault();

    var type = userType;

    const response = await fetch(
      config.domainName + ":" + config.port + "/api/registertype",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          password,
          type,
        }),
      }
    );

    const content = await response.json();

    handleJustifyClick("tab1");
  };

  return (
    <div className="loginPageContainer">
      <div className="mainContainer">
        <img className="logoImg" />
        <div className="imageColumnContainer">
          <div
            className="bg-image"
            style={{
              backgroundImage: "url('/loginPageBackground.jpg",
            }}
          >
            {/* className="m-5 p-4 text-light" */}
            <h1>
              20+ YEARS OF <br></br>EXPERIENCE IN <br></br>{" "}
              <span>CYBERSECURITY</span>
              <br></br>IN THE GULF
            </h1>
          </div>
        </div>
        <div className="formColumnContainer">
          <form id="signInform" onSubmit={submitLogin}>
            <div className="mb-3 text-dark">
              <h1 style={{ fontWeight: "bold" }}>Sign In</h1>
            </div>
            <hr
              className="hr"
              width="50px"
              style={{ borderTop: "2px solid rgba(0, 0, 0, 0.1)" }}
            />

            <div className="inputForm">
              <div>
                <strong style={{ paddingBottom: "1%" }}>Username</strong>
                <div>
                  <input
                    className="form-control rounded-8 inputBox"
                    placeholder="Username"
                    id="usernameValidation"
                    type="text"
                    required
                    feedback={usernameFeedback}
                    onChange={(e) => {
                      setName(e.target.value);
                      setUsernameFeedback("");
                      setFeedback("");
                    }}
                  />
                </div>
              </div>
              <div>
                <strong style={{ paddingBottom: "1%" }}>Password</strong>
                <div className="passwordInput">
                  <input
                    className="form-control rounded-8 inputBox"
                    placeholder="Password"
                    id="passwordValidation"
                    type={passwordVisible ? "text" : "password"}
                    required
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordFeedback("");
                      setFeedback("");
                    }}
                  />
                  <button
                    id="toggle"
                    color="none"
                    type="button"
                    className="hidePasswordIcon"
                    onClick={() => setPasswordVisible(!passwordVisible)}
                  >
                    {passwordVisible ? (
                      <AiIcons.AiFillEye />
                    ) : (
                      <AiIcons.AiFillEyeInvisible />
                    )}
                  </button>
                </div>
              </div>
            </div>

            {feedback !== "" && (
              <Alert variant="danger" style={{ whiteSpace: "pre-wrap" }}>
                {feedback}
              </Alert>
            )}

            {!loginSubmit ? (
              <MDBBtn
                className="signInButton rounded-pill"
                type="submit"
                form="signInform"
              >
                <h6>Sign In</h6>
              </MDBBtn>
            ) : (
              <MDBBtn
                className="mb-2 mt-4 w-50 rounded-pill pt-3"
                disabled
                style={{ backgroundColor: "#0550F0" }}
              >
                <MDBSpinner
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />
                <h6>Loading...</h6>
              </MDBBtn>
            )}
          </form>
          {/* <MDBCard className="p-1 w-100" style={{ maxWidth: "40rem" }}>
            <MDBCardBody>
              <MDBTabs
                pills
                justify
                className="mb-3 d-flex flex-row justify-content-between"
              >
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("tab1")}
                    active={justifyActive === "tab1"}
                    style={{
                      backgroundColor:
                        justifyActive === "tab1" ? "#0550F0" : "",
                    }}
                  >
                    Login
                  </MDBTabsLink>
                </MDBTabsItem>
                <MDBTabsItem>
                  <MDBTabsLink
                    onClick={() => handleJustifyClick("tab2")}
                    active={justifyActive === "tab2"}
                    style={{
                      backgroundColor:
                        justifyActive === "tab2" ? "#0550F0" : "",
                    }}
                  >
                    Register
                  </MDBTabsLink>
                </MDBTabsItem>
              </MDBTabs>

              <MDBTabsContent>
                <MDBTabsPane show={justifyActive === "tab1"}>
                  <form
                    id="signInform"
                    //   onSubmit={submit}
                    onSubmit={submitLogin}
                  >
                    <div className="mb-3">
                      <h1>Sign In</h1>
                    </div>
                    <div className="mb-3">
                      <p>lorem Ipsum is simply dummy text</p>
                    </div>

                    <MDBInputGroup className="mb-3">
                      <input
                        className="form-control rounded-8 p-4"
                        placeholder="Username"
                        id="usernameValidation"
                        type="text"
                        required
                        feedback={usernameFeedback}
                        onChange={(e) => {
                          setName(e.target.value);
                          setUsernameFeedback("");
                          setFeedback("");
                        }}
                      />
                      <input
                        className="form-control rounded-8 p-4"
                        placeholder="Password"
                        id="passwordValidation"
                        type={passwordVisible ? "text" : "password"}
                        required
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setPasswordFeedback("");
                          setFeedback("");
                        }}
                      />

                      <MDBBtn
                        tag="a"
                        color="none"
                        className="m-1"
                        style={{ color: "#0550F0" }}
                        onClick={() => setPasswordVisible(!passwordVisible)}
                      >
                        {passwordVisible ? (
                          <AiIcons.AiFillEye />
                        ) : (
                          <AiIcons.AiFillEyeInvisible />
                        )}
                      </MDBBtn>
                    </MDBInputGroup>

                    {/* {password && (
                      <PasswordChecklist
                        rules={["minLength", "specialChar", "number", "letter"]}
                        minLength={8}
                        value={password}
                        onChange={(isValid) => {
                          if (isValid) {
                            setIsValidLoginForm(true);
                          } else {
                            setIsValidLoginForm(true);
                          }
                        }}
                      />
                    )} 

                    {feedback !== "" && (
                      <Alert variant="danger">{feedback}</Alert>
                    )}
                    {!loginSubmit ? (
                      <MDBBtn
                        className="mb-4 mt-4 w-100"
                        type="submit"
                        form="signInform"
                        style={{ backgroundColor: "#0550F0" }}
                      >
                        Sign in
                      </MDBBtn>
                    ) : (
                      <MDBBtn
                        className="mb-4 w-100"
                        disabled
                        style={{ backgroundColor: "#0550F0" }}
                      >
                        <MDBSpinner
                          size="sm"
                          role="status"
                          tag="span"
                          className="me-2"
                        />
                        Loading...
                      </MDBBtn>
                    )}
                  </form>
                </MDBTabsPane>
                <MDBTabsPane show={justifyActive === "tab2"}>
                  <form
                    id="signUpForm"
                    //   onSubmit={submit}
                    onSubmit={submitRegister}
                  >
                    <div className="text-center mb-3">
                      <p>Sign Up</p>
                    </div>
                    <MDBInput
                      wrapperclassName="mb-5"
                      label="Username"
                      id="username"
                      type="text"
                      required
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                    <MDBInput
                      wrapperclassName="mb-5"
                      label="Password"
                      id="password"
                      type="password"
                      required
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    />

                    <select
                      aria-label="Default select example"
                      className="mb-5 w-100"
                      onChange={(e) => {
                        if (e.target.value !== "Select User Type")
                          selectUserType(e.target.value);
                        else selectUserType("3");
                      }}
                    >
                      <option>Select User Type</option>
                      <option value="0">Admin</option>
                      <option value="1">Super User</option>
                      <option value="2">Entity</option>
                      <option value="3">Employee</option>
                    </select>

                    <MDBBtn
                      className="mb-5 w-100"
                      type="submit"
                      form="signUpForm"
                      style={{ backgroundColor: "#3E4DA1" }}
                    >
                      Sign up
                    </MDBBtn>
                  </form>
                </MDBTabsPane>
              </MDBTabsContent>
            </MDBCardBody>
          </MDBCard> */}
        </div>
      </div>

      {/* <MDBCard
        alignment="center"
        className="p-1 w-100"
        style={{ maxWidth: "40rem" }}
      >
        <MDBCardHeader alignment="center">
          <img src="/mainLogos/elguards-logo-blue.png" width={"80%"} />
        </MDBCardHeader>
        <MDBCardBody>
          <MDBTabs
            pills
            justify
            className="mb-3 d-flex flex-row justify-content-between"
          >
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleJustifyClick("tab1")}
                active={justifyActive === "tab1"}
                style={{
                  backgroundColor: justifyActive === "tab1" ? "#0550F0" : "",
                }}
              >
                Login
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink
                onClick={() => handleJustifyClick("tab2")}
                active={justifyActive === "tab2"}
                style={{
                  backgroundColor: justifyActive === "tab2" ? "#0550F0" : "",
                }}
              >
                Register
              </MDBTabsLink>
            </MDBTabsItem>
          </MDBTabs>

          <MDBTabsContent>
            <MDBTabsPane show={justifyActive === "tab1"}>
              <form
                id="signInform"
                //   onSubmit={submit}
                onSubmit={submitLogin}
              >
                <div className="text-center mb-3">
                  <p>Sign in</p>
                </div>
                <MDBInput
                  wrapperclassName="mb-5"
                  label="Username"
                  id="usernameValidation"
                  type="text"
                  required
                  feedback={usernameFeedback}
                  onChange={(e) => {
                    setName(e.target.value);
                    setUsernameFeedback("");
                    setFeedback("");
                  }}
                />

                <MDBInputGroup className="mb-3">
                  <input
                    className="form-control"
                    placeholder="Password"
                    id="passwordValidation"
                    type={passwordVisible ? "text" : "password"}
                    required
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordFeedback("");
                      setFeedback("");
                    }}
                  />

                  <MDBBtn
                    tag="a"
                    color="none"
                    className="m-1"
                    style={{ color: "#3E4DA1" }}
                    onClick={() => setPasswordVisible(!passwordVisible)}
                  >
                    {passwordVisible ? (
                      <AiIcons.AiFillEye />
                    ) : (
                      <AiIcons.AiFillEyeInvisible />
                    )}
                  </MDBBtn>
                </MDBInputGroup>

                {password && (
                  <PasswordChecklist
                    rules={["minLength", "specialChar", "number", "letter"]}
                    minLength={8}
                    value={password}
                    onChange={(isValid) => {
                      if (isValid) {
                        setIsValidLoginForm(true);
                      } else {
                        setIsValidLoginForm(true);
                      }
                    }}
                  />
                )}

                {feedback !== "" && <Alert variant="danger">{feedback}</Alert>}
                {!loginSubmit ? (
                  <MDBBtn
                    className="mb-4 mt-4 w-100"
                    type="submit"
                    form="signInform"
                    style={{ backgroundColor: "#3E4DA1" }}
                  >
                    Sign in
                  </MDBBtn>
                ) : (
                  <MDBBtn
                    className="mb-4 w-100"
                    disabled
                    style={{ backgroundColor: "#3E4DA1" }}
                  >
                    <MDBSpinner
                      size="sm"
                      role="status"
                      tag="span"
                      className="me-2"
                    />
                    Loading...
                  </MDBBtn>
                )}
              </form>
            </MDBTabsPane>
            <MDBTabsPane show={justifyActive === "tab2"}>
              <form
                id="signUpForm"
                //   onSubmit={submit}
                onSubmit={submitRegister}
              >
                <div className="text-center mb-3">
                  <p>Sign Up</p>
                </div>
                <MDBInput
                  wrapperclassName="mb-5"
                  label="Username"
                  id="username"
                  type="text"
                  required
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
                <MDBInput
                  wrapperclassName="mb-5"
                  label="Password"
                  id="password"
                  type="password"
                  required
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                />

                <Form.Select
                  aria-label="Default select example"
                  className="mb-5 w-100"
                  onChange={(e) => {
                    if (e.target.value !== "Select User Type")
                      selectUserType(e.target.value);
                    else selectUserType("3");
                  }}
                >
                  <option>Select User Type</option>
                  <option value="0">Admin</option>
                  <option value="1">Super User</option>
                  <option value="2">Entity</option>
                  <option value="3">Employee</option>
                </Form.Select>

                <MDBBtn
                  className="mb-5 w-100"
                  type="submit"
                  form="signUpForm"
                  style={{ backgroundColor: "#3E4DA1" }}
                >
                  Sign up
                </MDBBtn>
              </form>
            </MDBTabsPane>
          </MDBTabsContent>
        </MDBCardBody>
      </MDBCard> */}
    </div>
  );
}

export default Login;
